{
  "Authentication_LoginButton": "Aanmelden",
  "LoginForm_LoginTitle": "Meld u aan bij uw account",
  "LoginForm_WelcomeBack": "Welkom terug! Vul uw gegevens in.",
  "LoginForm_Email": "Gebruikersnaam",
  "LoginForm_EmailRequired": "E-mail is vereist",
  "LoginForm_InvalidEmail": "Gebruikersnaam moet een e-mailadres zijn",
  "LoginForm_EmailPlaceholder": "Voer uw e-mailadres in",
  "LoginForm_Password": "Wachtwoord",
  "LoginForm_PasswordRequired": "Wachtwoord is vereist",
  "LoginForm_PasswordPlaceholder": "••••••••",
  "LoginForm_RememberMe": "Onthoud mij",
  "LoginForm_ForgotPassword": "Wachtwoord vergeten",
  "LoginForm_SignIn": "Aanmelden",
  "NAME": "Authentication",
  "LoginForm_Username": "Gebruikersnaam",
  "LoginForm_UsernameRequired": "Gebruikersnaam is vereist",
  "LoginForm_UsernamePlaceholder": "Voer uw gebruikersnaam in",
  "LoginForm_CME": "CME",
  "LoginForm_Or": "(Of)",
  "LoginForm_Server": "Server",
  "LoginForm_ServerPlaceholder": "Selecteer de server waarop u zich wilt aanmelden",
  "LoginForm_LoginLanding_UserOnMultipleServices": "Deze gebruikersnaam bestaat op meerdere services. Geef aanvullende informatie om uw gebruiker te identificeren.",
  "LoginForm_LoginLanding_UserNonAdmin_Error": "Er is een probleem met inloggen op uw account. Neem contact op met uw beheerder om het probleem te verhelpen.",
  "LoginForm_LandingPage_NextButton": "Doorgaan",
  "Authentication_ChangeBrowserProfile": "Browserprofiel wijzigen",
  "LoginForm_LoginLanding_User_Not_Found_Error": "We konden de gebruikersnaam die je hebt ingevoerd niet vinden. Controleer het nogmaals en probeer het opnieuw."
}